import fetchWithCache from './fetchWithCache';
import { fetchJSON } from '@bonnet/next/fetch';

const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

const fetchLocationSiteMap = (isKbb) => (isKbb
    ? fetchJSON('/car-dealers/sitemaps/kbb_location_dealers.json')
    : fetchJSON('/car-dealers/sitemaps/atc_location_dealers.json'));

export default async function getValidLocationsFromSiteMap(isKbb) {
    const cacheKey = isKbb ? 'sitemapLocations_kbb' : 'sitemapLocations_atc';

    let urlsLocationFromSiteMap = null;

    try {
        urlsLocationFromSiteMap = await fetchWithCache(fetchLocationSiteMap, isKbb, cacheKey, CACHE_TTL);
    } catch (error) {
        return [];
    }

    const validLocationsFromSiteMap = [];

    if (urlsLocationFromSiteMap?.urls?.length > 0) {
        urlsLocationFromSiteMap.urls.forEach((url) => {
            const data = url.split('/').filter((part) => part !== '');
            const cityState = data[data.length - 1];

            validLocationsFromSiteMap.push(cityState);
        });
    }

    return validLocationsFromSiteMap;
}
